module.exports = "../study/imgs/maps/Tokyo/GWQ8/Climate/DailyPrecipitation0/Tokyo_DailyPrecipitation0_MRI_RCP85_End.png";